import { createTheme, type MantineColorsTuple } from "@mantine/core";

const brassTuple: MantineColorsTuple = [
  "#f6efe6",
  "#e7d6bf",
  "#d4b78d",
  "#c2995d",
  "#b48140",
  "#a37330",
  "#9a6b3f",
  "#7a5530",
  "#5d4023",
  "#3f2b18",
];

export const theme = createTheme({
  primaryColor: "brass",
  primaryShade: 6,
  colors: {
    brass: brassTuple,
  },
  defaultRadius: "xs",
  cursorType: "pointer",
  respectReducedMotion: true,
  fontFamily: '"Switzer", ui-sans-serif, system-ui, sans-serif',
  fontFamilyMonospace: '"JetBrains Mono Variable", ui-monospace, monospace',
  headings: {
    fontFamily: '"Fraunces Variable", ui-serif, Georgia, serif',
    fontWeight: "500",
    sizes: {
      h1: { fontSize: "3rem", lineHeight: "1.1" },
      h2: { fontSize: "2rem", lineHeight: "1.2" },
      h3: { fontSize: "1.5rem", lineHeight: "1.3" },
    },
  },
  components: {
    Button: {
      defaultProps: {
        radius: "xs",
      },
      styles: {
        root: {
          fontWeight: 500,
          letterSpacing: "0.01em",
          transitionDuration: "180ms",
          transitionTimingFunction: "ease-out",
        },
      },
    },
    TextInput: {
      defaultProps: {
        variant: "unstyled",
      },
      styles: {
        input: {
          borderBottom: "1px solid var(--hairline)",
          borderRadius: 0,
          paddingInline: 0,
          fontSize: "1rem",
          color: "var(--ink)",
          backgroundColor: "transparent",
          transition: "border-color 180ms ease-out",
        },
        label: {
          color: "var(--ink-muted)",
          fontSize: "0.85rem",
          fontWeight: 500,
        },
      },
    },
    PasswordInput: {
      defaultProps: {
        variant: "unstyled",
      },
      styles: {
        input: {
          borderBottom: "1px solid var(--hairline)",
          borderRadius: 0,
        },
      },
    },
    Modal: {
      styles: {
        overlay: { backgroundColor: "var(--scrim)", backdropFilter: "blur(8px)" },
        content: { backgroundColor: "var(--bone)", borderRadius: 2 },
      },
    },
    Drawer: {
      styles: {
        overlay: { backgroundColor: "var(--scrim)", backdropFilter: "blur(8px)" },
        content: { backgroundColor: "var(--bone)" },
      },
    },
  },
});
